export default{

    getPlayer : state => {
        let playerState =  state.playerState
        let player = null
        if(playerState){
            player = playerState
        }else{
            let playerLocal = JSON.parse(localStorage.getItem('player'))
            player = playerLocal
        }
        return player
    }
}